var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"subtitle-1 mt-8 mb-2 text-uppercase font-weight-bold text-center"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"body-1 mb-8 text-center"},[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }